import {ImageRequestParams} from "../models/image/image-request-params";

export class EditImageRequestParams extends ImageRequestParams {
  constructor(width, height, color) {
    super({width, height, color});

    this._resourceName = `bolao24/Icons/Edit_Icon`;
  }
}
